import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import MapView from '@arcgis/core/views/MapView';
import Map from '@arcgis/core/Map';
import Point from '@arcgis/core/geometry/Point';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import Graphic from '@arcgis/core/Graphic';
import Basemap from '@arcgis/core/Basemap';
import Extent from '@arcgis/core/geometry/Extent';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';
import { FastAPIService, Solver } from 'src/app/service/fast-api.service';
import { MapService } from 'src/app/service/map-page.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  @ViewChild('mapPanel', { static: true }) mapPanel!: ElementRef;
  map: Map | null = null;
  mapView: MapView | null = null;
  points: Point[] = [];
  marker: PictureMarkerSymbol | null = null;
  pointGraphics: Graphic[] = [];
  clusterFeatureLayer: FeatureLayer | null = null;
  currentLocation: Point | null = null;
  mapReady: boolean = false;
  filter: string = "";

  constructor(private fastService: FastAPIService, private mapService: MapService, private route: ActivatedRoute, private router: Router) {}

  async ngOnInit() {
    this.filter = new Solver().solve().filter;

    // const basemap = new Basemap({
    //   portalItem: {
    //     id: "bc19c34549de4000bcd91cef929420dc",
        
    //   },
    // });

    const basemap = new Basemap({
      portalItem: {
        id: '28f49811a6974659988fd279de5ce39f'
      }
    });
    this.map = new Map({
      basemap: basemap,
    });

    this.mapView = new MapView({
      container: this.mapPanel.nativeElement,
      map: this.map,
      center: [100.523186, 13.736717],
      zoom: 15,
      constraints: {
        minZoom: 2,
        geometry: new Extent({
          xmin: -180,
          ymin: -80,
          xmax: 180,
          ymax: 75
        })
      },
      popupEnabled: false
    });

    await this.mapView.when();
    this.mapReady = true;

    // navigator.geolocation.getCurrentPosition(async resp => {
    //   this.currentLocation = new Point({
    //     latitude: resp.coords.latitude,
    //     longitude: resp.coords.longitude
    //   });
    // },
    // err => {
    //   this.currentLocation = new Point({
    //     latitude: 13.736717,
    //     longitude: 100.523186,
    //   });
    //     this.mapView?.goTo({
    //       center: [this.currentLocation.longitude, this.currentLocation.latitude],
    //       zoom: 15
    //     });
    // });

    await this.getPin();
    if (this.points.length > 0) {
      const points = await this.mapService.generatePointsWithOutMainNews(this.points);
      this.pointGraphics = this.mapService.createGraphicsFromPointsWithoutMainNews(points);
    }

    this.marker = new PictureMarkerSymbol({
      url: "assets/map-page-component-images/mainPin.svg",
      width: "46px",
      height: "58px"
    });

    if (this.pointGraphics.length > 0) {
      this.clusterFeatureLayer = new FeatureLayer({
        source: this.pointGraphics,
        objectIdField: "ObjectID",
        fields: [
          {
            name: "ObjectID",
            alias: "ObjectID",
            type: "oid"
          },
          {
            name: "Topic_OD",
            alias: "Topic",
            type: "string"
          },
          {
            name: "latitude",
            type: "string"
          },
          {
            name: "longitude",
            type: "string"
          },
          {
            name: "Detail_OD",
            alias: "Detail",
            type: "string"
          },
          {
            name: "Link_OD",
            alias: "Link",
            type: "string"
          },
          {
            name: "Picture_URL_OD",
            alias: "Picture",
            type: "string"
          },
          {
            name: "isMainNews",
            alias: "isMainNews",
            type: "string"
          }
        ],
        renderer: new UniqueValueRenderer({
          field: "isMainNews",
          defaultSymbol: this.marker,
        })
      });

      if (this.clusterFeatureLayer) {
        this.map.add(this.clusterFeatureLayer);
      }
    }

    if (this.clusterFeatureLayer && this.mapView) {
      this.mapService.generateClusterConfig(this.clusterFeatureLayer, this.mapView).then((featureReduction) => {
        if (this.clusterFeatureLayer) {
          this.clusterFeatureLayer.featureReduction = featureReduction as __esri.FeatureReductionCluster;
        }
      }).catch((error) => {
        console.log(error);
      });
    }

    if (this.mapView && this.pointGraphics.length > 0) {
      this.mapView.goTo(this.pointGraphics);
    }
  }

  async getPin() {
      const response: any[] = await this.fastService.getALLLatLon();
      this.points = response;
  }

  onAiSearch(input: string) {
    this.router.navigate(['/home/ai_summary', {input: input}])
  }

  onSearch(input: string) {
    this.router.navigate(['/home/search', {relativeTo: this.route, input: input}])
  }
}
